import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n-lite';
import { bindActionCreators } from 'redux';

import CustomIcon from '../../common/CustomIcon';
import CustomCheckbox from '../../common/CustomCheckbox';
import SanitizedString from '../../common/SanitizedString';
import * as lessonListContainerService from './lessonListContainerService';
import * as activityService from '../../../services/domain/activityService';
import * as assignmentsDrawerActions from '../../../actions/assignmentsDrawerActions';
import * as translateService from '../../../services/translate/customTranslateService';
import * as bookActions from '../../../actions/bookActions';

class LessonListContainer extends React.Component {
  static propTypes = {
    activities: PropTypes.array,
    checkedActivities: PropTypes.array,
    editable: PropTypes.bool,
    assignmentsDrawerActions: PropTypes.any,
    colors: PropTypes.any,
    lessons: PropTypes.object,
    setAllChecked: PropTypes.func,
    setLessons: PropTypes.func,
    updateAllActivitiesChecks: PropTypes.func,
    isAllChecked: PropTypes.bool,
    setShowButtons: PropTypes.func,
    bookActions: PropTypes.object,
    task: PropTypes.object,
    selectedTask: PropTypes.object,
    units: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.onChangeLesson = this.onChangeLesson.bind(this);
    this.onChangeActivity = this.onChangeActivity.bind(this);
    this.state = {
      bookInfo: null,
      noContent: null
    };
  }

  componentDidMount() {
    const { units } = this.props;
    if (!units) {
      this.getBookInfo()
        .then(bookInfo => {
          this.setState({ bookInfo });
        })
        .catch(error => {
          this.setState({ noContent: error });
        });
    }
  }

  isAllLessonsChecked() {
    const { lessons, setAllChecked, isAllChecked, setShowButtons } = this.props;
    const len = _.size(lessons);
    const checked = _.size(
      _.filter(lessons, v => {
        return v.checked === true;
      })
    );

    if (checked === len) {
      setAllChecked(true);
    } else {
      if (checked === len - 1 && isAllChecked) {
        setAllChecked(false);
      }
    }
  }

  onChangeLesson(lesson) {
    const { assignmentsDrawerActions, setLessons, lessons, setShowButtons } = this.props;

    lesson.checked = !lesson.checked;

    if (lesson.activities) {
      Object.values(lesson.activities).forEach(activity => {
        activity.checked = lesson.checked;
      });
    }

    lessons[lesson.activityId] = lesson;
    setLessons(lessons);
    assignmentsDrawerActions.onCheckedActivitiesChange(lessonListContainerService.getActivitiesChecked(lessons));
    this.isAllLessonsChecked();
    setShowButtons(true);
  }

  onChangeActivity(lessonActivityId, activity) {
    const { assignmentsDrawerActions, setLessons, lessons, setShowButtons } = this.props;
    const lesson = lessons[lessonActivityId];
    const len = _.size(lesson.activities);
    let allActivitiesCompleted = [];

    activity.checked = !activity.checked;
    lesson[activity.activityId] = activity;

    Object.values(lesson.activities).forEach(lessonActivity => {
      if (lessonActivity.checked) {
        allActivitiesCompleted.push(lessonActivity);
      }
    });

    let checked = _.size(allActivitiesCompleted);

    if (checked === len) {
      this.onChangeLesson(lesson);
    } else {
      if (checked === len - 1 && lesson.checked) {
        lesson.checked = !lesson.checked;
        this.isAllLessonsChecked();
      }
    }

    setLessons(lessons);
    setShowButtons(true);
    assignmentsDrawerActions.onCheckedActivitiesChange(lessonListContainerService.getActivitiesChecked(lessons));
  }

  setAllActitvitiesChecked = () => {
    const { isAllChecked, setShowButtons, updateAllActivitiesChecks } = this.props;
    updateAllActivitiesChecks();
    setShowButtons(!isAllChecked);
  };

  renderUnitsAndLessons(units, lessons) {
    return units.map(unit => {
      const unitName = unit.name[Object.keys(unit.name)[0]];

      return (
        <div key={unit.activityId}>
          <div className="lesson-unit">{unitName}</div>
          {this.renderLessonsForUnit(unit, lessons)}
        </div>
      );
    });
  }

  async getBookInfo() {
    const { bookActions, task, selectedTask } = this.props;
    return bookActions.getBookInfo(task.classroomId, selectedTask.bookId);
  }

  renderLessonsForUnit(unit, lessons) {
    const { editable } = this.props;

    const lessonsForUnit = Object.values(lessons).filter(
      lesson =>
        unit.content.some(content => content.activityId === lesson.activityId) &&
        Object.keys(lesson.activities).length > 0
    );

    return lessonsForUnit.map(lesson => (
      <div className="lesson-row" key={lesson.activityId}>
        <label>
          <CustomCheckbox
            keyName={lesson.activityId}
            checked={lesson.checked}
            isDisabled={!editable}
            handleChange={() => this.onChangeLesson(lesson)}
          />
          <SanitizedString rawString={translateService.translateObject(lesson.name)} />
        </label>
        <div className="activity-row-container">{this.renderActivities(lesson)}</div>
      </div>
    ));
  }

  render() {
    const { lessons, units, isAllChecked, editable, colors, updateAllActivitiesChecks } = this.props;
    const { bookInfo, noContent } = this.state;

    if (noContent) {
      return <div className="activity-content-not-found">{I18n.t('panels.assignment.contentTaskNotFound')}</div>;
    }

    return (
      <div className="lesson-list-container-wrapper">
        <div className="select-all-container" style={{ backgroundColor: colors.backgroundSecondary }}>
          <label>
            <CustomCheckbox
              checked={isAllChecked}
              isDisabled={!editable}
              handleChange={this.setAllActitvitiesChecked}
            />
            <span>{I18n.t('panels.assignment.selectAll')}</span>
          </label>
        </div>
        <div className="lesson-row-container">
          {units
            ? this.renderUnitsAndLessons(units, lessons)
            : bookInfo
            ? this.renderUnitsAndLessons(bookInfo.content, lessons)
            : null}
        </div>
      </div>
    );
  }

  renderActivities(lesson) {
    const { editable } = this.props;
    return Object.values(lesson.activities).map(activity => {
      if (!lessonListContainerService.isAudioOrVideoActivity(activity.activityType)) {
        return (
          <div className="activity-row" key={activity.activityId}>
            <label>
              <CustomCheckbox
                keyName={activity.activityId}
                checked={activity.checked}
                isDisabled={!editable}
                handleChange={() => this.onChangeActivity(lesson.activityId, activity)}
              />
              <CustomIcon size={20} name={activityService.getActivityIcon(activity.activityType)} />
              <SanitizedString rawString={translateService.translateObject(activity.name)} />
            </label>
          </div>
        );
      }
      return undefined;
    });
  }
}

function mapStateToProps(state) {
  return {
    colors: state.theme.colors,
    selectedTask: state.task.selectedTask
  };
}

function mapDispatchToProps(dispatch) {
  return {
    assignmentsDrawerActions: bindActionCreators(assignmentsDrawerActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LessonListContainer);
